import React from 'react';
import './styles/value.css';
import CTAKnap, { CTAIkoner } from './ctaknap';

const Value = () => {
  return (
    <section className="value">
      <div className="container">
        <div className="value-header">
          <h2 className="value-title">
            Hvorfor er det relevant at få en <span className="highlight-positive">professionel hjemmeside</span>?
          </h2>
          <p className="value-subtitle">
            En hjemmeside er så meget mere end et visitkort. Den kan ende med at være en stor, unødvendig udgift, eller den kan være en effektiv måde at sælge på, uden at du skal gøre noget. Vores mål er, at det bliver det sidste.
          </p>
        </div>

        <div className="value-grid">
          {/* Problem Items */}
          <div className="value-column">
            <div className="column-header">
              <div className="column-icon negative">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 8v4"/>
                  <path d="M12 16h.01"/>
                </svg>
              </div>
              <h3>Dine udfordringer</h3>
            </div>
            
            <div className="value-items">
              <div className="value-item">
                <div className="item-icon negative">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M12 8v4"/>
                    <path d="M12 16h.01"/>
                  </svg>
                </div>
                <div className="item-content">
                  <h4 className="item-title">Lav synlighed på Google</h4>
                  <p className="item-desc">Din hjemmeside rangerer ikke højt nok, når dine potentielle kunder søger efter dine ydelser, og du går glip af trafik (kunder).</p>
                </div>
              </div>
              
              <div className="value-item">
                <div className="item-icon negative">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M12 8v4"/>
                    <path d="M12 16h.01"/>
                  </svg>
                </div>
                <div className="item-content">
                  <h4 className="item-title">Forvirrende design</h4>
                  <p className="item-desc">Besøgende har svært ved at finde rundt på din side og forstå, hvad du tilbyder, hvilket får dem til at forlade siden hurtigt.</p>
                </div>
              </div>
              
              <div className="value-item">
                <div className="item-icon negative">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M12 8v4"/>
                    <path d="M12 16h.01"/>
                  </svg>
                </div>
                <div className="item-content">
                  <h4 className="item-title">Langsom indlæsningstid</h4>
                  <p className="item-desc">En for langsom side frustrerer brugeren og skader din troværdighed, hvilket resulterer i et højt frafald.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Solution Items */}
          <div className="value-column">
            <div className="column-header">
              <div className="column-icon positive">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 12l2 2 4-4"/>
                  <circle cx="12" cy="12" r="10"/>
                </svg>
              </div>
              <h3>Vores løsning</h3>
            </div>
            
            <div className="value-items">
              <div className="value-item">
                <div className="item-icon positive">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4"/>
                    <circle cx="12" cy="12" r="10"/>
                  </svg>
                </div>
                <div className="item-content">
                  <h4 className="item-title">Bedre placeringer på Google</h4>
                  <p className="item-desc">Vi optimerer din hjemmeside med relevant SEO, så du bliver fundet af dine drømmekunder og skaber en konstant strøm af trafik.</p>
                </div>
              </div>
              
              <div className="value-item">
                <div className="item-icon positive">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4"/>
                    <circle cx="12" cy="12" r="10"/>
                  </svg>
                </div>
                <div className="item-content">
                  <h4 className="item-title">Enestående brugeroplevelse</h4>
                  <p className="item-desc">Vi designer en intuitiv og overskuelig hjemmeside med fokus på navigation, så dine besøgende hurtigt finder, hvad de leder efter.</p>
                </div>
              </div>
              
              <div className="value-item">
                <div className="item-icon positive">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4"/>
                    <circle cx="12" cy="12" r="10"/>
                  </svg>
                </div>
                <div className="item-content">
                  <h4 className="item-title">Øget konvertering</h4>
                  <p className="item-desc">Vi går altid efter at omdanne flere besøgende til faktiske kunder gennem design og optimering.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="value-cta">
          <h3>Få en hjemmeside der skaber synlighed og vækst</h3>
          <p>Vi giver en gratis konsultation og viser hvordan vi kan hjælpe din virksomhed</p>
          <div className="value-cta-actions">
            <CTAKnap 
              variant="primary" 
              size="large"
              href="/omos"
              icon={<CTAIkoner.ArrowRight />}
            >
              Mød os
            </CTAKnap>
            <CTAKnap 
              variant="outline" 
              size="large"
              href="/kontakt"
              icon={<CTAIkoner.ExternalLink />}
            >
              Kontakt os
            </CTAKnap>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Value;
